/**
 * The official KKP mark, from `docs/console-mockup/kkp-logo.svg` — the file the mockup
 * pulled from `bank.kkpfg.com/Content/Images/logo/kkb-logo-white.svg`.
 *
 * Referenced across the workspace rather than copied into this package, for the same
 * reason `@catalogue` is an alias and not a copy: one set of bytes, nothing to drift.
 * The mockup inlines the markup because an Artifact's CSP blocks external images; here
 * Vite inlines it as a data URI anyway (2.8 KB, under `assetsInlineLimit`), so the built
 * console makes no extra request either.
 *
 * Decorative: the masthead states the product name in text right next to it, so the
 * image carries no information a screen reader would otherwise miss.
 *
 * It is KKP's trademark: it belongs in work done for KKP and nowhere else.
 */
import logoUrl from '../../../../docs/console-mockup/kkp-logo.svg';

export function KkpLogo() {
  return (
    <span className="logo">
      <img src={logoUrl} alt="" aria-hidden="true" width={118} height={32} />
    </span>
  );
}
